import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance90 = () => {
  let winners = [
    "366", "512"
  ];
  return <IndividualTable matchType={"4"} gender="M" event="90" subTitle="TarscaShild" data={sampleData} topRankCount="2" winners={winners} />;
};
export default Distance90;
